import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React from 'react';
import useStyles from './QAAccordion.style';

const QAAccordion = (props) => {
  const { question, answer, id, handleChange } = props;
  const classes = useStyles();
  return (
    <Accordion onChange={handleChange}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={`faq${id}-content`}
        id={`faq${id}-header`}>
        <Typography className={classes.question}>{question}</Typography>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.accordionDetails }}>{answer}</AccordionDetails>
    </Accordion>
  );
};

export default QAAccordion;
